import {ViewTypeVo} from '../../common/shared/api/karina/vo/enums/ViewTypeVo.enum';
import {RankingStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/RankingStaticLandingPageVo.interface';
import {
  GroupType,
  LayoutType,
  Maybe,
  SectionType,
  StaticLandingRankingParamInput,
  StaticLandingRankingSection,
  StaticLandingType,
  User,
} from '../generated/types';
import {createDisplayAd} from './DisplayAd';
import {createItem} from './Item';
import {createPromotionBannerItem} from './PromotionBannerItem';
import {createSortOption} from './SortOption';
import {createStaticLandingRankingSectionParam} from './StaticLandingRankingSectionParam';

export function createStaticLandingRankingSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    rankingStaticLandingPageVo: vo,
    input,
    type = LayoutType.Landing,
    withOperationArea,
  }: {
    sectionId?: string;
    rankingStaticLandingPageVo: RankingStaticLandingPageVo;
    input: StaticLandingRankingParamInput;
    type?: Maybe<LayoutType>;
    withOperationArea?: boolean;
  }
): StaticLandingRankingSection {
  const param = createStaticLandingRankingSectionParam(vo, input);
  const isSeriesCardView = vo.view_type === ViewTypeVo.SeriesCardView;

  return {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.Ranking}-section-${type}-${
        param.categoryUid
      }-${param.subcategory?.param}-${param.rankingType?.param}${
        input.screenUid ? `-${input.screenUid}` : ''
      }`,
    type: SectionType.LandingRanking,
    groups: [
      {
        id: `static-landing-${StaticLandingType.Ranking}-group-${
          param.categoryUid
        }-${param.subcategory?.param}-${
          input.screenUid ? `-${input.screenUid}` : ''
        }${input.screenUid ? `-${input.screenUid}` : ''}-${
          param.rankingType?.param
        }`,
        type:
          vo.view_type === ViewTypeVo.SeriesCardView
            ? GroupType.CardView
            : GroupType.PosterView,
        items:
          vo.list?.map((item, index) =>
            createItem(userInfo, {
              viewItemVo: {
                viewItem: item,
                viewType: isSeriesCardView
                  ? ViewTypeVo.SeriesCardView
                  : ViewTypeVo.SeriesPosterView,
                sectionType: SectionType.LandingRanking,
              },
              index: (input.page ?? 0) * 25 + index,
            })
          ) || [],
      },
    ],
    categoryTabList:
      vo.cat_opt_list.map(opt => createSortOption({sortOptVo: opt})) || [],
    subcategoryList:
      vo.subcat_opt?.map(opt => createSortOption({sortOptVo: opt})) || [],
    rankingTypeList:
      vo.rank_sort_opt?.map(opt => createSortOption({sortOptVo: opt})) || [],
    isEnd: vo.is_end,
    rankingTime: vo.ranking_time,
    title: vo.title,
    totalCount:
      input.page === 0 || input.page === undefined
        ? vo.list?.length
        : undefined,
    displayAd:
      type === LayoutType.Landing && vo.display_ad
        ? createDisplayAd(vo.display_ad)
        : undefined,
    promotionBanner:
      type === LayoutType.Landing && vo.section_promotion_banner
        ? createPromotionBannerItem(vo.section_promotion_banner)
        : undefined,
    withOperationArea,
    viewType: vo.view_type,
    param,
  };
}
